import React from "react";
import { withStyles, Paper, Breadcrumbs, Modal } from '@material-ui/core';

import { organizadorSessoesAndamentoListQuery, prolongaSessaoPorId, encerraSessaoPorId, encerraTransmissaoPorId, iniciaTransmissao, adicionaParticipanteSessao } from '../../graphql/Sessao';
import autoBind from 'react-autobind';
import { Query, withApollo } from "react-apollo";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { Button, Row, Col } from 'react-bootstrap';
import Typography from '@material-ui/core/Typography';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import ProlongarSessao from './popup/prolongar-sessao';
import IniciarTransmissao from './popup/iniciar-transmissao';
import EncerrarSessao from './popup/encerrar-sessao';
import EncerrarTransmissao from './popup/encerrar-transmissao';
import AdicionarParticipantes from './popup/adicionar-participante';
import ExibirConviadosSessao from './popup/exibir-convidados-sessao';
import ExibirLinkAcesso from './popup/exibir-link-acesso';
import Environment from "../../environment/environment";

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
    },
    card: {
        marginLeft: "20px",
        marginTop: "20px"
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    modalWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    cardButtonsBox: {
        alignItems: 'stretch'
    },
    noSessionsFound: {
        fontSize: '14px',
        color: '#000'
    }
});

class OrgEmAndamento extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            verArquivados: false,
            definicaoSelecionada: null,
            showProlongarSessaoModal: false,
            showEncerrarSessaoModal: false,
            showEncerrarTransmissaoModal: false,
            showIniciarTransmissaoModal: false,
            showAdicionarParticipanteModal: false,
            showVerConvidadosModal: false,
            showExibirLinkAcessoModal: false,
        }

        autoBind(this);
    }

    render() {
        const { classes } = this.props;
        return (
            <Paper className={classes.root}>
                <Row>
                    <Col>
                        {this.renderBreadCrumb()}
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {this.renderSessoesAndamento()}
                    </Col>
                </Row>
            </Paper >
        );
    }

    renderSessoesAndamento() {
        const { classes } = this.props;

        this._queryVariables = {};

        return (
            <Query query={organizadorSessoesAndamentoListQuery} variables={{ ...this._queryVariables }} fetchPolicy='network-only'>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...'
                    if (error) return `Error! ${error.message}`

                    this.query_organizadorSessoesAndamentoListQuery_refetch = refetch;
                    const { organizadorSessoesAndamentoList } = data;

                    const sessoesEmAndamento = organizadorSessoesAndamentoList.map( (sess, index) => {
                        return (
                            <div key={sess.id}>
                                {this.renderSessaoCard(sess)}
                            </div>
                        );
                    });

                    const noSessionsFound = () => {
                        return (
                            <Col md={12}>
                                <p className={classes.noSessionsFound}>Nenhuma sessão em andamento neste momento.</p>
                            </Col>
                        );
                    }

                    return <div className="row">
                        { organizadorSessoesAndamentoList.length > 0 ? sessoesEmAndamento : noSessionsFound() }
                        {this.defineModalProlongarSessao()}
                        {this.defineEncerrarSessaoModal()}
                        {this.defineIniciarTransmissaoModal()}
                        {this.defineEncerrarTransmissaoModal()}
                        {this.defineAdicionarParticipanteModal()}
                        {this.defineExibirConvidadosModal()}
                        {this.defineExibirLinkAcessoModal()}
                    </div>
                }}
            </Query>
        );
    }

    renderSessaoCard(sessao) {
        const { classes } = this.props;
        const dataSessaoInicio = Environment.momentToLocalDateAndTimeWithoutYearString(sessao.inicio);
        const dataSessaoFim = Environment.momentToLocalDateAndTimeWithoutYearString(sessao.fim);

        return (
            <Card className={classes.card}>
                <CardContent>
                    <Typography variant="h5" component="h2">
                        {sessao.nome}
                    </Typography>
                    <Typography className={classes.pos} color="textSecondary">
                        {dataSessaoInicio} a {dataSessaoFim}
                    </Typography>
                </CardContent>

                {(sessao.permite_acesso_via_link ?
                    <CardActions className={classes.cardButtonsBox}>
                        <Button variant="green" style={{width: "100%"}} onClick={() => this.handleShowExibirLinkAcessoModal(sessao.id)}>Ver Link de Acesso</Button>
                    </CardActions>
                    : null )
                }

                <CardActions className={classes.cardButtonsBox}>
                    <Button variant="green" onClick={() => this.handleShowExibirConvidadosModal(sessao.id)}>Ver Convidados</Button>
                    <Button variant="green" onClick={() => this.handleShowAdicionarParticipanteModal(sessao.id)}>Adicionar Convidado</Button>
                </CardActions>

                <CardActions className={classes.cardButtonsBox}>
                    <Button size="small" style={{width: "100%", backgroundColor: "#880000 !important"}} variant="green" onClick={() => this.handleShowProlongarSessaoModal(sessao.id, sessao.fim)}>Prolongar</Button>
                    <Button variant="red" onClick={() => this.handleShowEncerrarSessaoModal(sessao.id)}>Encerrar</Button>
                </CardActions>

                {
                    ( sessao.layout_participante.id_descritivo.indexOf("transmissao_") != -1) ?
                        <CardActions className={classes.cardButtonsBox}>
                            { ( sessao.transmitindo ?
                                    <Button size="small" style={{width: "100%"}} variant="green" onClick={() => this.handleShowEncerrarTransmissaoModal(sessao.id)}>Encerrar Transmissão</Button>
                                    : <Button size="small" style={{width: "100%"}} variant="green" onClick={() => this.handleShowIniciarTransmissaoModal(sessao.id, sessao.stream_url, sessao.stream_key)}>Iniciar Transmissão</Button>
                            ) }
                        </CardActions>
                        : null
                }

            </Card>
        );
    }

    handleShowExibirLinkAcessoModal(sessionId) {
        this.setState({
            showExibirLinkAcessoModal: true,
            sessionId
        });
    }

    handleCloseExibirLinkAcessoModal() {
        this.setState({
            showExibirLinkAcessoModal: false,
            sessionId: null,
        });
    }

    defineExibirLinkAcessoModal() {
        const { showExibirLinkAcessoModal, sessionId } = this.state;
        const { classes } = this.props;
        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={showExibirLinkAcessoModal}
                onClose={this.handleClose}
                className={classes.modal}
            >
                <div className={classes.modalWrapper}>
                    <Paper className={classes.root}>
                        <ExibirLinkAcesso
                            sessionId={sessionId}
                            handleModalClose={this.handleCloseExibirLinkAcessoModal} />
                    </Paper>
                </div>
            </Modal>
        );
    }

    handleShowExibirConvidadosModal(sessionId) {
        this.setState({
            showVerConvidadosModal: true,
            sessionId
        });
    }

    handleCloseExibirConvidadosModal(sessionId) {
        this.setState({
            showVerConvidadosModal: false,
            sessionId: null,
        });
    }

    defineExibirConvidadosModal() {
        const { showVerConvidadosModal, sessionId } = this.state;
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={showVerConvidadosModal}
                onClose={this.handleClose}
                className={classes.modal}
            >
                <div className={classes.modalWrapper}>
                    <Paper className={classes.root}>
                        <ExibirConviadosSessao
                            sessionId={sessionId}
                            handleModalClose={this.handleCloseExibirConvidadosModal} />
                    </Paper>
                </div>
            </Modal>
        );
    }

    defineAdicionarParticipanteModal() {
        const { showAdicionarParticipanteModal, sessionId } = this.state;
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={showAdicionarParticipanteModal}
                onClose={this.handleClose}
                className={classes.modal}
            >
                <div className={classes.modalWrapper}>
                    <Paper className={classes.root}>
                        <AdicionarParticipantes
                            sessionId={sessionId}
                            handleModalClose={this.handleAdicionarParticipanteModalClose}
                            handleModalSaveChange={this.handleSaveAdicionarParticipanteModal} />
                    </Paper>
                </div>
            </Modal>
        );
    }

    defineEncerrarSessaoModal() {
        const { showEncerrarSessaoModal, sessionId } = this.state;
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={showEncerrarSessaoModal}
                onClose={this.handleClose}
                className={classes.modal}
            >
                <div className={classes.modalWrapper}>
                    <Paper className={classes.root}>
                        <EncerrarSessao
                            sessionId={sessionId}
                            handleModalClose={this.handleEncerrarSessaoModalClose}
                            handleModalSaveChange={this.handleSaveEncerrarSessaoModal} />
                    </Paper>
                </div>
            </Modal>
        );
    }

    defineIniciarTransmissaoModal() {
        const { showIniciarTransmissaoModal, sessionId, streamUrl, streamKey } = this.state;
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={showIniciarTransmissaoModal}
                onClose={this.handleClose}
                className={classes.modal}
            >
                <div className={classes.modalWrapper}>
                    <Paper className={classes.root}>
                        <IniciarTransmissao
                            sessionId={sessionId}
                            streamUrl={streamUrl}
                            streamKey={streamKey}
                            handleModalClose={this.handleIniciarTransmissaoModalClose}
                            handleModalSaveChange={this.handleSaveIniciarTransmissaoModal} />
                    </Paper>
                </div>
            </Modal>
        );
    }

    defineEncerrarTransmissaoModal() {
        const { showEncerrarTransmissaoModal, sessionId } = this.state;
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={showEncerrarTransmissaoModal}
                onClose={this.handleClose}
                className={classes.modal}
            >
                <div className={classes.modalWrapper}>
                    <Paper className={classes.root}>
                        <EncerrarTransmissao
                            sessionId={sessionId}
                            handleModalClose={this.handleEncerrarTransmissaoModalClose}
                            handleModalSaveChange={this.handleSaveEncerrarTransmissaoModal} />
                    </Paper>
                </div>
            </Modal>
        );
    }

    defineModalProlongarSessao() {
        const { showProlongarSessaoModal, sessionId, dataSessaoFim } = this.state;
        const { classes } = this.props;

        return (
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={showProlongarSessaoModal}
                onClose={this.handleClose}
                className={classes.modal}
            >
                <div className={classes.modalWrapper}>
                    <Paper className={classes.root}>
                        <ProlongarSessao
                            sessionId={sessionId}
                            dataSessaoFim={dataSessaoFim}
                            handleModalClose={this.handleModalProlongarSessaoClose}
                            handleModalSaveChange={this.handleSaveProlongarDataFimSessao} />
                    </Paper>
                </div>
            </Modal>
        );
    }

    // modal encerrar transmissão
    handleShowEncerrarTransmissaoModal(sessionId) {
        this.setState({
            showEncerrarTransmissaoModal: true,
            sessionId: sessionId,
        });
    }

    handleEncerrarTransmissaoModalClose() {
        this.setState({
            showEncerrarTransmissaoModal: false,
            sessionId: null
        });
    }

    handleSaveEncerrarTransmissaoModal() {
        const { sessionId } = this.state;
        const { client } = this.props;

        client.mutate({
            mutation: encerraTransmissaoPorId,
            variables: {
                id: sessionId
            }
        }).then(data => {
            this.query_organizadorSessoesAndamentoListQuery_refetch();
            Swal.fire({
                title: "Transmissão encerrada!",
                text: "Transmissão encerrada com sucesso",
                icon: "success",
                confirmButtonColor: "#5d5d5d",
                showCancelButton: false,
            });
        }).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao encerrar transmissão",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });

        this.setState({
            showEncerrarTransmissaoModal: false,
            sessionId: null
        });
    }


    // modal encerrar transmissão
    handleShowIniciarTransmissaoModal(sessionId, streamUrl, streamKey) {
        this.setState({
            showIniciarTransmissaoModal: true,
            sessionId,
            streamUrl,
            streamKey,
            skipStart: null
        });
    }

    handleIniciarTransmissaoModalClose() {
        this.setState({
            showIniciarTransmissaoModal: false,
            sessionId: null
        });
    }

    handleSaveIniciarTransmissaoModal(sessionId, streamUrl, streamKey, skipStart) {
        const { client } = this.props;

        client.mutate({
            mutation: iniciaTransmissao,
            variables: {
                id: sessionId,
                stream_url: streamUrl,
                stream_key: streamKey,
                skip_start: skipStart
            }
        }).then(data => {
            this.query_organizadorSessoesAndamentoListQuery_refetch();

            if(!skipStart) {
                Swal.fire({
                    title: "Transmissão iniciada!",
                    text: "Transmissão iniciada com sucesso",
                    icon: "success",
                    confirmButtonColor: "#5d5d5d",
                    showCancelButton: false,
                });
            } else {
                Swal.fire({
                    title: "Sucesso!",
                    text: "Dados da transmissão foram salvos",
                    icon: "success",
                    confirmButtonColor: "#5d5d5d",
                    showCancelButton: false,
                });
            }
        }).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao iniciar transmissão",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });

        this.setState({
            showIniciarTransmissaoModal: false,
            sessionId: null
        });
    }

    // modal encerrar sessão
    handleShowEncerrarSessaoModal(sessionId) {
        this.setState({
            showEncerrarSessaoModal: true,
            sessionId: sessionId,
        });
    }

    handleEncerrarSessaoModalClose() {
        this.setState({
            showEncerrarSessaoModal: false,
            sessionId: null
        });
    }

    handleSaveEncerrarSessaoModal() {
        const { sessionId } = this.state;
        const { client } = this.props;

        client.mutate({
            mutation: encerraSessaoPorId,
            variables: {
                id: sessionId
            }
        }).then(data => {
            this.query_organizadorSessoesAndamentoListQuery_refetch();
            Swal.fire({
                title: "Sessão encerrada!",
                text: "Sessão encerrada com sucesso",
                icon: "success",
                confirmButtonColor: "#5d5d5d",
                showCancelButton: false,
            });
        }).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao encerrar sessão",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });

        this.setState({
            showEncerrarSessaoModal: false,
            sessionId: null
        });
    }

    // modal adicionar participantes
    handleShowAdicionarParticipanteModal(sessionId) {
        this.setState({
            showAdicionarParticipanteModal: true,
            sessionId
        });
    }

    handleAdicionarParticipanteModalClose() {
        this.setState({
            showAdicionarParticipanteModal: false,
            sessionId: null
        });
    }

    handleSaveAdicionarParticipanteModal(userId, roleId) {
        const { sessionId } = this.state;
        const { client } = this.props;

        client.mutate({
            mutation: adicionaParticipanteSessao,
            variables: {
                sessaoId: sessionId,
                participanteId: userId,
                papelId: roleId,
            }
        }).then(data => {
            this.query_organizadorSessoesAndamentoListQuery_refetch();
            Swal.fire({
                title: "Participante Adicionado!",
                text: "Novo participante adicionado com sucesso",
                icon: "success",
                confirmButtonColor: "#5d5d5d",
                showCancelButton: false,
            });
        }).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao adicionar participante",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });

        this.setState({
            showAdicionarParticipanteModal: false,
            sessionId: null
        });
    }

    // modal prolongar sessao
    handleShowProlongarSessaoModal(sessionId, dataFim) {
        this.setState({
            showProlongarSessaoModal: true,
            sessionId,
            dataSessaoFim: dataFim,
        });
    }

    handleModalProlongarSessaoClose() {
        this.setState({
            showProlongarSessaoModal: false,
            sessionId: null
        });
        this.query_organizadorSessoesAndamentoListQuery_refetch()
    }

    handleSaveProlongarDataFimSessao(newEndDate) {
        const { sessionId } = this.state;
        const { client } = this.props;

        const momentIsoDate = moment(newEndDate).toISOString();

        client.mutate({
            mutation: prolongaSessaoPorId,
            variables: {
                id: sessionId,
                novaDataFim: momentIsoDate
            }
        }).then(data => {
            this.query_organizadorSessoesAndamentoListQuery_refetch();
            Swal.fire({
                title: "Sessão prolongada!",
                text: "Sessão prolongada com sucesso",
                icon: "success",
                confirmButtonColor: "#5d5d5d",
                showCancelButton: false,
            });
        }).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao prolongar sessão",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });

        this.setState({
            showProlongarSessaoModal: false,
            sessionId: null
        });
    }

    renderBreadCrumb() {
        const { } = this.props;

        return (
            <Breadcrumbs aria-label="Breadcrumb" className="bradcrumbs">
                <Typography >Organizar</Typography>
                <Typography >Gerenciar Sessões</Typography>
                <span>Em andamento</span>
            </Breadcrumbs>
        );
    }

}

export default (withApollo(withStyles(styles)(OrgEmAndamento)));